const FEATURE_FLAG_PREFIX = "ff_";

export const getFeatureFlagOverride = (flagName: string): boolean | null => {
	if (typeof window === "undefined") {
		return null;
	}

	const params = new URLSearchParams(window.location.search);
	const paramKey = `${FEATURE_FLAG_PREFIX}${flagName}`;
	const paramValue = params.get(paramKey);

	if (paramValue === null) {
		return null;
	}

	if (paramValue === "true" || paramValue === "1") {
		return true;
	}

	if (paramValue === "false" || paramValue === "0") {
		return false;
	}

	return null;
};
